import React from 'react';
import PropTypes from 'prop-types';

import Utils from '../../utils/utils';
import i18n from '../../i18n';
import { Icon } from '@homeexchange/design';

const FriendCard = (props) => {
    const defaultProfile = `${Utils.getAssetsDomain()}/images/website/icon_default_profile.jpg`;

    return (
        <div className="item-my-friends">
            <div className="profil-side">
                <img src={props.friend.image ? props.friend.image.cdn_link : defaultProfile} />
                <div className="profil-detail">
                    <span className="friend-name">{props.friend.first_name}</span>
                    <a
                        href={i18n.t('user:user.view.url', { id: props.friend.id })}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <span>{i18n.t('user:see_profile')}</span>
                    </a>
                </div>
            </div>
            <div className="milestone-side">
                <div className="active">
                    <Icon name="Check" />
                    {i18n.t('sponsorship:account_created')}
                </div>
                <div className={`${props.friend.milestones.is_qualified_home ? 'active' : ''}`}>
                    <Icon name="Check" />
                    {i18n.t('sponsorship:milestone_home_complete')}
                </div>
                <div className={`${props.friend.milestones.is_membership ? 'active' : ''}`}>
                    <Icon name="Check" />
                    {i18n.t('sponsorship:milestone_membership')}
                </div>
            </div>
        </div>
    );
};

FriendCard.propTypes = {
    friend: PropTypes.shape({
        id: PropTypes.number,
        first_name: PropTypes.string,
        image: PropTypes.shape({
            cdn_link: PropTypes.string
        }),
        milestones: PropTypes.shape({
            is_qualified_home: PropTypes.bool,
            is_membership: PropTypes.bool
        })
    })
};

export default FriendCard;
